// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"358":"d973d44d","415":"706df7e3"}[chunkId] + ".js";
};